export const COMPANY = {
  productName: "Rivyou",
  legalName: "CLAP Ventures",
  email: "help@rivyou.co",
  website: "https://truuh.com",
  linkedin: "https://www.linkedin.com/company/rivyou",
  instagram: "https://www.instagram.com/rivyou.official/",
  facebook: "https://www.facebook.com/people/Rivyou/61584136863602/",
  addressLines: [
    "D-330, Golden Corner Apartments",
    "Sarjapur Marathahalli Road, Bellandur",
    "Bengaluru - 560103, Karnataka, India",
  ],
  gstin: "29AMDPG3205G1ZG",
};

export const TEAM_MEMBERS = [
  {
    name: "Lokesh Gupta",
    role: "Founder",
    linkedin: "https://www.linkedin.com/in/lokesh-gupta-96268b14/",
    photo: "/team/lokesh.jpg",
  },
  {
    name: "Aaroh Maheshwari",
    role: null,
    linkedin: "https://www.linkedin.com/in/aaroh-maheshwari-403896234/",
    photo: "/team/aaroh.jpg",
  },
  {
    name: "Prashanth V",
    role: "Backend Developer",
    linkedin: "https://www.linkedin.com/in/prashanth1615/",
    photo: "/team/prashanth.jpg",
  },
];
